import React, { useContext, useRef } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import withMediaQuery from "flexbiz-core/components/withMediaQuery";
import { 
  Box, Typography, Card, CardContent, CardActionArea, Button, 
  CardActions, Chip, Grid 
} from '@mui/material';
import AuthContext from "flexbiz-core/components/auth/Context";
import DataListManager from 'flexbiz-core/components/DataListManager';

import SecureImage from 'flexbiz-core/components/SecureImage';

import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SquareFootOutlinedIcon from '@mui/icons-material/SquareFootOutlined';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; 
import AccessTimeIcon from '@mui/icons-material/AccessTime';       
import StyleIcon from '@mui/icons-material/Style';                 
import BlockIcon from '@mui/icons-material/Block'; // Thêm icon Ngừng
import BottomNavigation from "../BottomNavigation";
function MyProducts(props) {
  const context = useContext(AuthContext);
  const managerRef = useRef(null);
  const history = useHistory();

  // ================= 1. HÀM TIỆN ÍCH =================
  const formatPrice = (price) => {
    if (!price || isNaN(price)) return 'Thỏa thuận';
    if (price >= 1000000000) return (price / 1000000000).toLocaleString('vi-VN', { maximumFractionDigits: 2 }) + ' Tỷ';
    if (price >= 1000000) return (price / 1000000).toLocaleString('vi-VN', { maximumFractionDigits: 0 }) + ' Triệu';
    return new Intl.NumberFormat('vi-VN').format(price) + ' đ';
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return '---';
    return new Date(isoString).toLocaleString('vi-VN', { 
      hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' 
    });
  };

  const getImageUrl = (item) => {
    const imagePath = item.picture || item.hinh_anh;
    if (!imagePath || !context?.config?.server_url || !context?.config?.public_token) return null;
    const slash = imagePath.startsWith('/') ? '' : '/';
    return `${context.config.server_url}${slash}${imagePath}?access_token=${context.config.public_token}`;
  };

  // ================= 2. XỬ LÝ SỰ KIỆN CLICK & ACTION =================
  const handleViewDetail = (item) => {
    const group_name = (context.appInfo?.par?.group?.group_name || "").toLowerCase();
    let page = item.la_du_an_chu_dau_tu && group_name.indexOf("môi giới") >= 0 
      ? `nhadat_agent_moigioi` 
      : `nhadat_agent`;
    context.objectView(page, item._id);
  };

  const handleStopProduct = (e, item) => {
    e.stopPropagation(); // Ngăn chặn mở trang chi tiết khi bấm nút Ngừng
    
    context.alert("Bạn có chắc chắn muốn ngừng giao dịch bất động sản này?", async (ok) => {
      if (ok) {
        context.setProgressStatus(true);
        try {
          // Payload cập nhật trạng thái
          const payload = { 
            _id: item._id, 
            trang_thai: "9", 
            id_app: context.config?.id_app || "" 
          };
          
          await context.apis.asyncPostList(context.userInfo.token, "nhadat", payload);

          // Ép UI cập nhật mượt mà trực tiếp qua managerRef
          if (managerRef.current) {
            managerRef.current.updateLocalItem({ 
              ...item, 
              trang_thai: "9",
              ten_trang_thai: "Ngừng giao dịch", // Cập nhật tên trạng thái mới
              color: "#8e8e93" // Đổi màu trạng thái sang xám để báo hiệu đã đóng
            });
          }
          context.alert("Đã ngừng hiển thị bất động sản thành công!");
        } catch (error) {
          context.alert(error.message || error.error || "Lỗi khi cập nhật trạng thái", null, "red");
        } finally {
          context.setProgressStatus(false);
        }
      }
    }, "red");
  };

  // ================= 3. RENDER PROPERTY CARD =================
  const renderRealEstateCard = (item, index, onEdit, onDelete) => {
    let src_image = getImageUrl(item);
    
    // Ép kiểu chuỗi để so sánh cho an toàn (Tránh lỗi 1 === '1')
    const currentStatus = String(item.trang_thai);

    return (
      <Card 
        key={item._id || index} 
        sx={{ 
          //mb: 2.5, 
          borderRadius: 4, 
          boxShadow: '0 4px 20px rgba(0,0,0,0.06)', 
          border: 'none', overflow: 'hidden',
          // Tạo dải viền màu nhẹ bên mép trái dựa theo màu trạng thái
          borderLeft: item.color ? `4px solid ${item.color}` : 'none'
        }}
      >
        <CardActionArea onClick={() => handleViewDetail(item)}>
          
          <Box sx={{ position: 'relative' }}>
            {!!src_image && <SecureImage
                alt={item.ten_nd}
                effect="blur" 
                src={src_image}
                width="100%"
                height="100%"
                style={{ objectFit: 'cover', display: 'block', height: 200 }} 
                wrapperProps={{ style: { display: 'block', width: '100%' } }} 
            />}
            
            <Chip 
              label={formatPrice(item.gia_ban)} 
              sx={{ position: 'absolute', bottom: 12, left: 12, bgcolor: 'rgba(0, 0, 0, 0.75)', color: '#fff', fontWeight: '900', fontSize: '1rem', height: 32, backdropFilter: 'blur(4px)' }} 
            />
            
            {item.ten_nhom && (
              <Chip label={item.ten_nhom} size="small" sx={{ position: 'absolute', top: 12, left: 12, bgcolor: '#ff3b30', color: 'white', fontWeight: 'bold' }} />
            )}

            {item.phan_loai && (
              <Chip label={item.phan_loai} size="small" sx={{ position: 'absolute', top: 12, right: 12, bgcolor: 'rgba(0,0,0,0.6)', color: 'white', fontWeight: 'bold' }} />
            )}
          </Box>

          <CardContent sx={{ p: '16px !important' }}>
            
            <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {item.ten_nd || 'Bất động sản chưa cập nhật tên'}
            </Typography>
            
            {/* CỤM MÃ BĐS VÀ CHIP TRẠNG THÁI NỔI BẬT */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1, mt: 0.5 }}>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                Mã: {item.ma_nd || '---'}
              </Typography>
              
              {item.ten_trang_thai && (
                <Chip 
                  label={item.ten_trang_thai} 
                  size="small" 
                  sx={{ 
                    bgcolor: item.color || '#e5e5ea', 
                    color: item.color ? '#fff' : '#1c1c1e', // Đảm bảo chữ trắng nếu có nền màu
                    fontWeight: 'bold', 
                    fontSize: '0.65rem', 
                    height: 20 
                  }} 
                />
              )}
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'flex-start', color: 'text.secondary', mb: 1.5 }}>
              <LocationOnOutlinedIcon sx={{ fontSize: 16, mr: 0.5, mt: 0.2 }} />
              <Typography variant="body2" noWrap>{item.tinh_thanh || 'Chưa cập nhật vị trí'}</Typography>
            </Box>

            <Grid container spacing={1} sx={{ bgcolor: '#f8f9fa', p: 1.5, borderRadius: 2, mb: 1.5 }}>
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <SquareFootOutlinedIcon sx={{ fontSize: 18, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" fontWeight="600">{item.dien_tich ? `${item.dien_tich} m²` : '---'}</Typography>
                </Box>
              </Grid>
              
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <AspectRatioIcon sx={{ fontSize: 16, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" fontWeight="600">
                    {item.chieu_ngang && item.chieu_dai ? `${item.chieu_ngang}m x ${item.chieu_dai}m` : (item.chieu_ngang ? `Ngang ${item.chieu_ngang}m` : '---')}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sx={{ mt: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <StyleIcon sx={{ fontSize: 16, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>Đơn giá:</Typography>
                  <Typography variant="body2" fontWeight="bold" color="#ff9500">
                    {item.gia_ban_m2 ? `${new Intl.NumberFormat('vi-VN').format(item.gia_ban_m2)} đ/m²` : 'Thỏa thuận'}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                <PersonOutlineIcon sx={{ fontSize: 16, mr: 0.5 }} />
                <Typography variant="caption" noWrap sx={{ maxWidth: 140, fontWeight: 500 }}>
                  {item.name_user_created || 'Ẩn danh'}
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                <AccessTimeIcon sx={{ fontSize: 14, mr: 0.5 }} />
                <Typography variant="caption">{formatDateTime(item.date_created)}</Typography>
              </Box>
            </Box>

          </CardContent>
        </CardActionArea>

        {/* NÚT ACTION XUẤT HIỆN TÙY THEO TRẠNG THÁI */}
        {currentStatus === '1' && (
          <CardActions sx={{ px: 2, pb: 2, pt: 0, justifyContent: 'flex-end' }}>
            <Button 
              variant="outlined" 
              color="error" 
              size="small" 
              startIcon={<BlockIcon />}
              onClick={(e) => handleStopProduct(e, item)}
              sx={{ 
                borderRadius: 2, textTransform: 'none', fontWeight: 'bold', 
                borderColor: 'rgba(211, 47, 47, 0.5)', '&:hover': { borderColor: '#d32f2f', bgcolor: 'rgba(211, 47, 47, 0.04)' } 
              }}
            >
              Ngừng giao dịch
            </Button>
          </CardActions>
        )}
      </Card>
    );
  };

  // ================= 4. CẤU HÌNH DATA LIST =================
  const nhadatFields = [
    { field: "ten_nd", label: "Tên bất động sản", type: "String", isTitle: true, required: true  },
    { field: "ma_nd", label: "Mã bất động sản", type: "String", isSubTitle: true, required: true  },
    { field: "phan_loai", label: "Phân loại", type: "Select",api:"phanloainhadat",apiMapping:{value:"ten_phan_loai",label:"ten_phan_loai"}, required: true  },
    { field: "nh_nd", label: "Kiểu BĐS", type: "Select", hideInList: true,api:"nhomnhadat",apiMapping:{value:"ma_nhom",label:"ten_nhom"}, required: true  },
    { field: "ten_nhom", label: "Nhóm BĐS", type: "String",searchable:false,hideInForm:true },
    { field: "gia_ban", label: "Giá bán", type: "Number", required: true  },
    { field: "gia_ban_m2", label: "Giá bán/m2", type: "Number" },
    { field: "chieu_ngang", label: "Mặt tiền", type: "Number", required: true },
    { field: "chieu_dai", label: "Chiều dài", type: "Number", required: true  },
    { field: "dien_tich", label: "Diện tích", type: "Number", required: true  },
    { field: "picture", label: "Hình đại diện", type: "String",searchable:false },
    { field: "tinh_thanh", label: "Tỉnh thành", type: "Autocomplete",api:"tinhthanh",apiMapping:{value:"ten_tinh_thanh",label:"ten_tinh_thanh"}, required: true   },
    { field: "dien_thoai_chu_so_huu", label: "Điện thoại", type: "String",searchable:false, required: true  },
    { field: "dien_thoai", label: "Điện thoại", type: "String",searchable:false,hideInForm:true },
    { field: "user_created", label: "Người đăng", type: "String", hideInForm: true,searchable:false },
    { field: "name_user_created", label: "Người đăng", type: "String",searchable:false, hideInForm: true },

    { field: "trang_thai", label: "Trạng thái", type: "String",searchable:false , hideInForm: true},
    { field: "ten_trang_thai", label: "Tên trạng thái", type: "String",searchable:false , hideInForm: true},
    { field: "color", label: "Màu trạng thái", type: "String",searchable:false , hideInForm: true},
    { field: "date_created", label: "Thời gian đăng", type: "DateTime",searchable:false, hideInForm: true },
  ];

  const bdsSortOptions = [
    { label: "Mới nhất", sort: { date_created: -1 } },
    { label: "Giá: Thấp đến cao", sort: { gia_ban: 1 } },
    { label: "Giá: Cao xuống thấp", sort: { gia_ban: -1 } },
    { label: "Diện tích: Nhỏ đến lớn", sort: { dien_tich: 1 } },
    { label: "Diện tích: Lớn xuống nhỏ", sort: { dien_tich: -1 } }
  ];

  return (
    <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <DataListManager
          ref={managerRef}
          title="Bất động sản của tôi"
          code="nhadat"
          fields={nhadatFields}
          condition={{ user_created:context.userInfo.email }}
          hideHeader={false}
          sortOptions={bdsSortOptions}
          
          transformData={(rawDataArray) => {
              return rawDataArray.map(item => ({
                  ...item,
                  dien_thoai: item.dien_thoai_chu_so_huu || context.appInfo?.phone
              }));
          }}
          listContainerSx={{ pb: 9, px: 2 }}
          containerSx={{ height: '100%' }}
          actionBarPosition="top"
          quickFilterConfig={{
              field: "trang_thai",
              api: "trangthai", 
              apiCondition:{ma_ct:"NHADAT"},
              apiMapping: { value: "ma_trang_thai", label: "ten_trang_thai" }
          }}
          canAdd={false}
          canEdit={false}
          canDelete={false}
          onBack={() => history.goBack()}
          renderItem={renderRealEstateCard}
      />
      <BottomNavigation history={history} code={"my-products"} />
    </Box>
  );
}

export default withRouter(withMediaQuery('(max-width:540px)')(MyProducts));